import React, { useState, useEffect } from "react";
import { Flex, Text, Box, Spinner, Icon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { primaryAlt, textSecondary } from "../../../../../utils/colors";
import useThemeColors from "../../../../../hooks/useThemeColors";
import { useSelector, useDispatch } from "react-redux";
import { getTenantSubscriptionUsageAction } from "../../../../../actions/tenantActions";
import dayjs from "dayjs";
import { motion } from "framer-motion";
import { useParams } from "react-router-dom";
import { TbRestore } from "react-icons/tb";

const MotionFlex = motion(Flex);

const ModuleLimitsNew = ({ isActive, moduleName, plan, nextBillingDate }) => {
  const { t } = useTranslation();
  const { slug } = useParams();

  const {
    whiteMode,
    planBorderSpecialMode,
    backgroundLightMode,
    textPrimaryMode,
    subscriptionStartDate,
  } = useThemeColors();

  const [usage, setUsage] = useState(null);

  // REDUX
  const dispatch = useDispatch();

  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  const {
    loading: loadingUsage,
    error: errorUsage,
    success: successUsage,
    limits,
  } = useSelector((state) => state.tenantGetSubscriptionUsage);

  // USE EFFECT
  useEffect(() => {
    if (slug && moduleName) {
      dispatch(getTenantSubscriptionUsageAction(moduleName, slug));
    }
  }, [dispatch, slug, moduleName]);

  // Pick the correct module's limits
  const moduleLimits = limits[moduleName] || { usageCount: 0, limitCount: 0 };

  // // LOG

  // console.log("limits", limits);
  // console.log("moduleName", moduleName);
  // console.log("usage", usage);

  // console.log("moduleName:", moduleName);
  // console.log("moduleLimits:", moduleLimits);

  // console.log(
  //   "translation",

  //   t("module.youCreatedThisMonth", {
  //     count: moduleLimits.usageCount,
  //     moduleName: t(`module.usage-${moduleName}`, {
  //       count: moduleLimits.usageCount,
  //     }),
  //   })
  // );

  // console.log("plan", plan);

  const subscriptionStartDateAddMonth = dayjs(subscriptionStartDate)
    .add(1, "month")
    .format("D MMM YYYY");

  return (
    <>
      <Box w="100%">
        {/* {isActive && (
          <Text
            fontSize="xs"
            color={textSecondary}
            fontWeight="500"
            textAlign="center"
            // textTransform="uppercase"
            textTransform="normal"
            p="0 0 0.5rem"
          >
            {plan === "free" ? (
              <span>
                {t("module.youCreatedThisMonthFree", {
                  count: moduleLimits.usageCount,
                  moduleName: t(`module.usage-${moduleName}`, {
                    count: moduleLimits.usageCount,
                  }),
                  date: subscriptionStartDateAddMonth,
                })}
              </span>
            ) : (
              <span>
                {t("module.youCreatedThisMonth", {
                  count: moduleLimits.usageCount,
                  moduleName: t(`module.usage-${moduleName}`, {
                    count: moduleLimits.usageCount,
                  }),
                  date: dayjs(nextBillingDate).format("MMMM DD"),
                })}
              </span>
            )}
          </Text>
        )} */}

        {isActive && (
          <>
            <Text
              fontSize="sm"
              color={textSecondary}
              fontWeight="500"
              textAlign="left"
              // textTransform="uppercase"
              textTransform="normal"
              p="0 0 1rem"
            >
              {t("module.createdNow", {
                count: moduleLimits.usageCount,
                limit: moduleLimits.limitCount,
              })}{" "}
              {/* Created {moduleLimits.usageCount} out of {moduleLimits.limitCount}{" "}
              treatment plans this month */}
            </Text>
          </>
        )}

        {!loadingUsage ? (
          <Flex
            w="100%"
            align="center"
            justify="space-between"
            m="0rem 0 0"
            gap="2rem"
          >
            {/* TREATMENT PLANS LIMIT */}
            <Flex w="100%" direction="column">
              <>
                <Flex w="100%" align="center" justify="space-between">
                  {moduleLimits.usageCount !== 0 && (
                    <MotionFlex
                      initial={{ width: "0%" }}
                      animate={{
                        width: `${
                          moduleLimits.limitCount > 0
                            ? (moduleLimits.usageCount /
                                moduleLimits.limitCount) *
                              100
                            : 0
                        }%`,
                      }}
                      transition={{ duration: 0.6 }}
                      bg={primaryAlt}
                      h="1rem"
                      borderRadius="0.75rem"
                      border={`1px solid ${backgroundLightMode}`}
                      position="relative"
                      opacity={isActive ? 1 : 0.2}
                    />
                  )}

                  <MotionFlex
                    initial={{ width: "0%" }}
                    animate={{
                      width: `${
                        moduleLimits.limitCount > 0
                          ? 100 -
                            (moduleLimits.usageCount /
                              moduleLimits.limitCount) *
                              100
                          : 100
                      }%`,
                    }}
                    transition={{ duration: 0.6 }}
                    bg={backgroundLightMode}
                    h="1rem"
                    borderRadius="0.75rem"
                    border={`1px solid ${backgroundLightMode}`}
                    bgImage={`linear-gradient(-45deg, ${whiteMode} 25%, ${planBorderSpecialMode} 25%, ${planBorderSpecialMode} 50%, ${whiteMode} 50%, ${whiteMode} 75%, ${planBorderSpecialMode} 75%, ${planBorderSpecialMode} 100%)`}
                    bgSize="10px 10px"
                  />
                </Flex>
                <Flex w="100%" align="center" p="1rem 0 0" opacity="0.8">
                  <Icon
                    as={TbRestore}
                    color={textSecondary}
                    fontSize="0.75rem"
                    mr={1}
                  />
                  <Text fontSize="xs" color={textSecondary} fontWeight="500">
                    {t("module.resetsOn")}{" "}
                    <Text as="span" textTransform="capitalize">
                      {dayjs(nextBillingDate).format("YYYY-MM-DD")}
                    </Text>
                  </Text>
                </Flex>
              </>
            </Flex>
            {/* EMAIL LIMIT */}

            {/* <Flex w="50%" direction="column">
              <Flex w="100%" align="center" justify="space-between">
                <Flex
                  w="23%"
                  bg={color4}
                  h="1.25rem"
                  borderRadius="0.75rem"
                  border={`1px solid ${backgroundLightMode}`}
                  position="relative"
                  opacity={isActive ? "1" : "0.2"}
                ></Flex>

                <Flex
                  w="77%"
                  bg={backgroundLightMode}
                  h="1.25rem"
                  borderRadius="0.75rem"
                  border={`1px solid ${backgroundLightMode}`}
                  bgImage={`linear-gradient(-45deg, ${whiteMode} 25%, ${planBorderSpecialMode} 25%, ${planBorderSpecialMode} 50%, ${whiteMode} 50%, ${whiteMode} 75%, ${planBorderSpecialMode} 75%, ${planBorderSpecialMode} 100%)`}
                  bgSize="10px 10px"
                />
              </Flex>
              <Flex
                w="100%"
                align="center"
                justify="space-between"
                p="0.25rem 0 0"
              >
                <Text fontSize="xs" color={textSecondary} fontWeight="500">
                  {t("dashboard.emailLimit")}
                </Text>
                <Text
                  fontSize="xs"
                  color={isActive ? textPrimaryMode : textSecondary}
                  fontWeight="500"
                >
                  5000
                  <Text as="span" color={textSecondary}>
                    / 60000
                  </Text>
                </Text>
              </Flex>
            </Flex> */}
          </Flex>
        ) : (
          <Flex w="100%" align="center" justify="center" minH="42px">
            <Spinner size="sm" />
          </Flex>
        )}
      </Box>
    </>
  );
};

export default ModuleLimitsNew;
